import API from '@axios'
import { stringify } from 'query-string'
import { apiHelper } from '@/helpers/apiHelper'

const API_URL = '/api/crm/crm_relationship_mapping'

export default {
  ...apiHelper(API_URL),

  list(query = {}) {
    return API.get(`${API_URL}/link?${stringify(query)}`)
  },

  link(id, payload) {
    return API.post(`${API_URL}/link`, payload)
  },

  updateLink(id, payload) {
    return API.patch(`${API_URL}/link/${id}`, payload)
  },

  unlink(id) {
    return API.patch(`${API_URL}/unlink/${id}`)
  },

  getOne(id, query = {}) {
    return API.get(`${API_URL}/link/${id}?${stringify(query)}`)
  },

  getAllByEntity(crmType, id, query = {}) {
    return API.get(`${API_URL}/${crmType}/${id}?${stringify(query)}`)
  },

  initiateExport(crmType, id, query) {
    return API.get(`${API_URL}/${crmType}/${id}/export?${stringify(query)}`)
  },

  getTreeByEntity(crmType, id, query) {
    return API.get(`${API_URL}/${crmType}/${id}/tree?${stringify(query)}`)
  },
  // Every related entity at any depth, whatever its status. Split out of the tree response
  // because building it costs a second full traversal, and only the Generate Document
  // subsidiary picker needs it.
  getTreeLeafMap(crmType, id) {
    return API.get(`${API_URL}/${crmType}/${id}/tree/leaf-map`)
  },
  getVarKontakt(varKontaktReq) {
    return API.post('/api/crm/company/var-kontakt', varKontaktReq)
  },
}
